import { debounce } from 'lodash';

export default function (actionCreators, debounceTime = 250) {
  const debouncedActionCreators = {};

  for (const name in actionCreators) {
    const actionCreator = actionCreators[name];
    debouncedActionCreators[name] = debounce((dispatch, ...args) => {
      return dispatch(actionCreator(...args));
    }, debounceTime);
  }

  return debouncedActionCreators;
}
